import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input } from 'antd';
import FormItem from "components/fields/FormItem";
import { 
	getJobRoleRequestDetails, 
	doJobRoleRequestArchive, 
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import { 
	doJobPostCreate, 
	doJobPostUpdate, 
} from "../../../../redux/jobpost/jobPostState";
import CrudButtons from "components/button/crudbuttons";
import { MODULE_JOBROLE_REQS, DATE_FORMAT } from "variables/constants";
import dayjs from "dayjs";
import JobRoleRequestFormFields from "./JobRoleRequestFormFields";
import Button from "components/button";
import JobPostFields from "../../job-posts/components/JobPostFields";

const JobRoleRequestForm = ({...props}) => {
	
	const dispatch = useDispatch();
  	const [form] = Form.useForm();
	const { recordId, mode } = props;

	const recordData = useSelector((state) => state.jobRoleRequest.jobRoleRequestDetails?.data);

	useEffect(() => {
		if(recordId){
			dispatch(getJobRoleRequestDetails(recordId));
		}
	},[dispatch, recordId]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { job_role:jobRole, jobPost, jrr_job_role_id, ...rest } = recordData;

			const initialValues = {
				...rest,
				...jobRole,
				...jobPost,
				jro_location: recordData.jrr_country_id,
				jrr_target_date: recordData?.jrr_target_date ? dayjs(recordData.jrr_target_date) : null,
				jpo_posting_date_from: jobPost?.jpo_posting_date_from ? dayjs(jobPost.jpo_posting_date_from) : null,
				jpo_posting_date_to: jobPost?.jpo_posting_date_to ? dayjs(jobPost.jpo_posting_date_to) : null,
				jro_key_responsibilities: Array.isArray(jobRole?.jro_key_responsibilities)
					? recordData.job_role?.jro_key_responsibilities
					: recordData.job_role?.jro_key_responsibilities
					? JSON.parse(recordData.job_role?.jro_key_responsibilities)
					: [""],
				jro_preferred_qualifications: Array.isArray(jobRole?.jro_preferred_qualifications)
					? recordData.job_role?.jro_preferred_qualifications
					: recordData.job_role?.jro_preferred_qualifications
					? JSON.parse(recordData.job_role?.jro_preferred_qualifications)
					: [""],
				jpo_key_responsibilities: Array.isArray(jobPost?.jpo_key_responsibilities)
					? recordData.jobPost?.jpo_key_responsibilities
					: recordData.jobPost?.jpo_key_responsibilities
					? JSON.parse(recordData.jobPost?.jpo_key_responsibilities)
					: [""],
				jpo_preferred_qualifications: Array.isArray(jobPost?.jpo_preferred_qualifications)
					? recordData.jobPost?.jpo_preferred_qualifications
					: recordData.jobPost?.jpo_preferred_qualifications
					? JSON.parse(recordData.jobPost?.jpo_preferred_qualifications)
					: [""],
			};	
			form.setFieldsValue(initialValues);
		}
    }, [recordData, form]);

  	const onSubmit = (formData) => {	
    	try {  
			formData.jpo_role_request_id = recordData.jrr_id;
			formData.jpo_client_id = recordData.jrr_client_id;
			formData.jpo_salary_range = recordData.jrr_budget_range;
			formData.jpo_posting_date_from = formData.jpo_posting_date_from?.format(DATE_FORMAT);
			formData.jpo_posting_date_to = formData.jpo_posting_date_to?.format(DATE_FORMAT);
			formData.jpo_department_id = recordData.jrr_department_id;
			recordData.jrr_job_post_id > 0 ? dispatch(doJobPostUpdate(formData)): dispatch(doJobPostCreate(formData)); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};

  	return (
    	<Form form={form}
			className="form"
			layout="vertical"
			onFinish={onSubmit}
			onFinishFailed={(e) => console.log('failed', e)}
		>   
			<FormItem
				name="jrr_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>

			<div className="pb-6 p-8 space-y-6">
				<JobRoleRequestFormFields recordData={recordData} mode="view"/>

				{((mode === "view" && recordData?.jrr_job_post_id > 0) || mode === 'edit') && 
					<div>
						<div className="border mb-4"></div>
						<h4 className="text-[16px] font-semibold">Job Post Details</h4>
						<JobPostFields recordData={recordData?.jobPost} mode={mode}/>
					</div>
				}
			</div>

			<div className="w-full flex justify-end">
				<CrudButtons
					mode={mode}
					baseRoute="/console/job-role-requests"
					recordId={recordData?.jrr_id ?? 0}
					updateLabel="Save Job Post"
					editLabel="Edit Job Post"
					withEdit={recordData?.jrr_job_post_id > 0}
					moduleId={0}
				>
					{(mode === 'view' && recordData?.jrr_job_post_id > 0 && recordData?.jrr_status_id !== 79) &&
						<Button 
							type="button" 
							className="crud-button btn-danger" 
							onClick={() => dispatch(doJobRoleRequestArchive(recordId))}
						>
							Archive
						</Button>
					}
					{mode === 'view' && !recordData?.jrr_job_post_id > 0 && 
						<Button 
							type="button" 
							className="crud-button" 
							onClick={() => {window.location.href = `/console/job-role-requests/${recordId}/job-post`}}
						>
							Create Job Post
						</Button>
					}
					{mode === 'view' && recordData?.jrr_job_post_id > 0 &&
						<a 
							className="btn crud-button" 
							href={`https://careers.hyvidone.com/job-posts/${recordData?.jrr_job_post_id}/view`}
							target="_blank"
						>
							Preview Job Post
						</a>
					}
				</CrudButtons>
			</div> 
		</Form>	 	
  	);
};

export default JobRoleRequestForm;
